import { useDispatch } from 'react-redux';
import {
	Button,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton,
	Tooltip,
	Typography
} from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import useSettings from '../../hooks/useSettings';
import useUserData from '../../hooks/useUserData';
import { GridListItem, type ItemLayoutProps } from '../../GridList';
import { showDeleteDialog } from '../../dialogs/DeleteDialog';
import Icon from '../../Icon';
import React from 'react';
import { AuthorizerContext } from 'app/providers/acl/AclProvider';

function FilterDetailsDialog({ model }: { model: any }) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	return (
		<>
			<DialogTitle>{t('DIALOG_TITLE_FILTER_DETAILS')}</DialogTitle>
			<DialogContent>
				{model.filt_value.map(filter => (
					<Grid container key={filter.filt_field}>
						<Grid size={4}>{t(filter.filt_label)}</Grid>
						<Grid size={4}>{t(`OPERATOR_${filter.filt_clause}`)}</Grid>
						<Grid size={4}>{t(filter.title || filter.filt_value_label || filter.filt_value)}</Grid>
					</Grid>
				))}
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_BACK')}</Button>
			</DialogActions>
		</>
	);
}

export default function FilterExternalListItem({ model, buttonProps }: ItemLayoutProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();
	const userData = useUserData();
	const authorizer = React.useContext(AuthorizerContext);

	function showFilterDetailsDialog() {
		dispatch(
			openDialog({
				children: <FilterDetailsDialog model={model} />,
				maxWidth: 'md',
				fullWidth: true
			})
		);
	}

	function handleDelete() {
		dispatch(
			showDeleteDialog({
				module: 'sys_filters_saved',
				id: model.filt_id,
				title: model.filt_name,
				hardDelete: true,
				replace: false,
				updateRefresh: buttonProps.updateRefresh
			})
		);
	}

	return (
		<GridListItem>
			<Grid container justifyContent="space-between" alignItems="center">
				<Grid size={4}>
					<Typography className="font-600" variant="subtitle2">
						{model.filt_name}
					</Typography>
				</Grid>
				<Grid size={4}>
					<Typography className="font-400" variant="subtitle2" color="text.secondary">
						{t(`MODULE_${model.filt_module}_NAME`)}
					</Typography>
				</Grid>
				<Grid>
					<Tooltip title={t('VIEW_ITEM_BUTTON_DETAILS')} arrow>
						<IconButton size="small" onClick={showFilterDetailsDialog}>
							<Icon icon="information" />
						</IconButton>
					</Tooltip>
					{model.filt_user_uid === userData.user_uid && (
						<Tooltip title={t('VIEW_ITEM_BUTTON_DELETE')} arrow>
							<IconButton
								size="small"
								onClick={handleDelete}
								hidden={authorizer.can('delete', 'filters_saved')}
							>
								<Icon icon="delete" />
							</IconButton>
						</Tooltip>
					)}
				</Grid>
			</Grid>
		</GridListItem>
	);
}
